// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChartAndNave_leftCol__MOD6F {
  margin-top: 90px !important;
}

.ChartAndNave_radar__HeUXH, .ChartAndNave_bar__YYaz7 {
  width: 100%;
}

.ChartAndNave_bar__YYaz7 {
  height: 400px;
}

.ChartAndNave_noDataTitle__Ubes2 {
  width: 90%;
  text-align: center;
  white-space: pre-wrap;
  font-family: "Barlow", Helvetica, sans-serif;
  font-weight: 600;
}

.ChartAndNave_rightCol__gHem8 {
  padding: 0 50px 0 10px;
  text-align: left;
  color: #8a8787;
  font-family: "Barlow", Helvetica, sans-serif;
  font-size: 22px;
  letter-spacing: 0.02em;
  margin-bottom: 20px;
}

.ChartAndNave_yourResults__3RU4c {
  margin-top: 85px;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: bold;
  display: inline-block;
  color: #ffffff;
  background-color: #000;
  padding: 3px 8px;
}

.ChartAndNave_linkItem__9zf47 {
  padding: 0;
}

.ChartAndNave_verticalSection__ebymJ {
  margin-left: 0% !important;
}

.ChartAndNave_vLinkItem__7ZfRO {
  padding: 5px !important;
  width: 24% !important;
  height: 320px;
}
@media (min-width: 992px) {
  .ChartAndNave_vLinkItem__7ZfRO {
    width: 24.3% !important;
    height: 330px;
    padding-left: 10px !important;
  }
}
@media (min-width: 1200px) {
  .ChartAndNave_vLinkItem__7ZfRO {
    width: 24.4% !important;
    padding-left: 20px !important;
  }
}
@media (min-width: 1400px) {
  .ChartAndNave_vLinkItem__7ZfRO {
    width: 24.5% !important;
    padding-left: 35px !important;
  }
}

.ChartAndNave_moduleTitle__K2Bl2, .ChartAndNave_vModuleTitle__4\\+XoL {
  font-size: 16px;
  margin: 5px;
}
.ChartAndNave_moduleTitle__K2Bl2 span, .ChartAndNave_vModuleTitle__4\\+XoL span {
  font-weight: 300;
  font-size: 14px;
}
@media (min-width: 768px) {
  .ChartAndNave_moduleTitle__K2Bl2, .ChartAndNave_vModuleTitle__4\\+XoL {
    font-size: 18px;
  }
  .ChartAndNave_moduleTitle__K2Bl2 span, .ChartAndNave_vModuleTitle__4\\+XoL span {
    font-size: 16px;
  }
}
@media (min-width: 992px) {
  .ChartAndNave_moduleTitle__K2Bl2, .ChartAndNave_vModuleTitle__4\\+XoL {
    font-size: 22px;
    margin: 5px 10px;
  }
  .ChartAndNave_moduleTitle__K2Bl2 span, .ChartAndNave_vModuleTitle__4\\+XoL span {
    font-size: 18px;
  }
}
@media (min-width: 1200px) {
  .ChartAndNave_moduleTitle__K2Bl2, .ChartAndNave_vModuleTitle__4\\+XoL {
    font-size: 1.4rem;
    margin: 12px 10px 12px;
  }
  .ChartAndNave_moduleTitle__K2Bl2 span, .ChartAndNave_vModuleTitle__4\\+XoL span {
    font-size: 20px;
  }
}

.ChartAndNave_vModuleTitle__4\\+XoL {
  line-height: normal;
  width: 300px;
  display: inline-block; /* Ensure the element is treated as a block for rotation */
  transform: rotate(-90deg); /* Rotate the text 90 degrees counterclockwise */
  transform-origin: left top; /* Set the origin point for the transformation */
  margin: 300px 0 0;
  white-space: pre-line;
}

.ChartAndNave_selectorSection__REvii {
  margin-top: 70px;
  padding: 20px 20px 40px;
  font-family: "Barlow", Helvetica, sans-serif;
  color: #000;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
}
.ChartAndNave_selectorSection__REvii .ChartAndNave_header__gZCuY {
  font-size: 20px;
  font-weight: 400;
}
.ChartAndNave_selectorSection__REvii .ChartAndNave_benchScope__0GOgE {
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 16px;
  background-color: rgba(229, 229, 229, 0.18);
  border: 1px solid #d9d9d9;
  border-radius: 5px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Results/ChartAndNav/ChartAndNave.module.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAIA;EACE,2BAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CCIW;EDHX,gBAAA;AAHF;;AAMA;EACE,sBAAA;EACA,gBAAA;EACA,cEZU;EFaV,4CCJW;EDKX,eCjBQ;EDkBR,sBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EAEA,qBAAA;EACA,cEfY;EFgBZ,sBElCY;EFmCZ,gBAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAQA;EACE,uBAAA;EACA,qBAAA;EAEA,aAAA;AANF;AAUE;EARF;IASI,uBAAA;IACA,aAAA;IACA,6BAAA;EAPF;AACF;AAQE;EAbF;IAcI,uBAAA;IACA,6BAAA;EALF;AACF;AAME;EAjBF;IAkBI,uBAAA;IACA,6BAAA;EAHF;AACF;;AAMA;EACE,eCjES;EDkET,WAAA;AAHF;AAKE;EACE,gBCjEO;EDkEP,eCrEY;ADkEhB;AAME;EATF;IAUI,eAAA;EAHF;EAIE;IACE,eC5EK;ED0ET;AACF;AAIE;EAfF;IAgBI,eClFM;IDmFN,gBAAA;EADF;EAEE;IACE,eAAA;EAAJ;AACF;AAEE;EAtBF;IAuBI,iBC7FI;ID8FJ,sBAAA;EACF;EAAE;IACE,eC3FK;ED6FT;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,qBAAA,EAAA,0DAAA;EACA,yBAAA,EAAA,gDAAA;EACA,0BAAA,EAAA,gDAAA;EACA,iBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,4CClGW;EDmGX,WEnHY;EFoHZ,yBAAA;EACA,mBAAA;AACF;AACE;EACE,eCnHO;EDoHP,gBC9GQ;AD+GZ;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,eCzHO;ED0HP,2CE5H0B;EF6H1B,yBAAA;EACA,0BAAA;AAAJ","sourcesContent":["@import '../../../styles/colors';\n@import \"../../../styles/mixins\";\n@import '../../../styles/variables';\n\n.leftCol {\n  margin-top: 90px !important;\n}\n\n.radar, .bar {\n  width: 100%;\n}\n\n.bar {\n  height: 400px;\n}\n\n.noDataTitle {\n  width: 90%;\n  text-align: center;\n  white-space: pre-wrap;\n  font-family: $ff-primary;\n  font-weight: $fw-semi-bold;\n}\n\n.rightCol {\n  padding: 0 50px 0 10px;\n  text-align: left;\n  color: $gray-text;\n  font-family: $ff-primary;\n  font-size: $fs-body;\n  letter-spacing: 0.02em;\n  margin-bottom: 20px;\n}\n\n.yourResults {\n  margin-top: 85px;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  font-weight: bold;\n  //color: $black-color;\n  display: inline-block;\n  color: $white-color;\n  background-color: $black-color;\n  padding: 3px 8px;\n}\n\n.linkItem {\n  padding: 0;\n}\n\n.verticalSection {\n  margin-left: 0% !important;\n  //margin-left: 5% !important;\n}\n\n.vLinkItem {\n  padding: 5px !important;\n  width: 24% !important; // override bootstrap's list-group-item-action\n  //text-align: center !important;\n  height: 320px;\n  //@media (min-width: 560px) {\n  //  padding-left: 8px !important;\n  //}\n  @media (min-width: 992px) {\n    width: 24.3% !important;\n    height: 330px;\n    padding-left: 10px !important;\n  }\n  @media (min-width: 1200px) {\n    width: 24.4% !important;\n    padding-left: 20px !important;\n  }\n  @media (min-width: 1400px) {\n    width: 24.5% !important;\n    padding-left: 35px !important;\n  }\n}\n\n.moduleTitle, .vModuleTitle {\n  font-size: $fs-small;\n  margin: 5px;\n\n  span {\n    font-weight: $fw-light;\n    font-size: $fs-very-small;\n  }\n\n  @media (min-width: 768px) {\n    font-size: 18px;\n    span {\n      font-size: $fs-small;\n    }\n  }\n  @media (min-width: 992px) {\n    font-size: $fs-body;\n    margin: 5px 10px;\n    span {\n      font-size: 18px;\n    }\n  }\n  @media (min-width: 1200px) {\n    font-size: $fs-h3;\n    margin: 12px 10px 12px;\n    span {\n      font-size: $fs-label;\n    }\n  }\n}\n\n.vModuleTitle {\n  line-height: normal;\n  width: 300px;\n  display: inline-block; /* Ensure the element is treated as a block for rotation */\n  transform: rotate(-90deg); /* Rotate the text 90 degrees counterclockwise */\n  transform-origin: left top; /* Set the origin point for the transformation */\n  margin: 300px 0 0;\n  white-space: pre-line;\n}\n\n.selectorSection {\n  margin-top: 70px;\n  padding: 20px 20px 40px;\n  font-family: $ff-primary;\n  color: $black-color;\n  border: 1px solid $gray-input-border;\n  border-radius: 10px;\n  //background-color: $light-gray-color;\n  .header {\n    font-size: $fs-label;\n    font-weight: $fw-normal;\n  }\n\n  .benchScope {\n    padding: 6px 12px;\n    margin-bottom: 0;\n    font-size: $fs-small;\n    background-color: $light-gray-input-background;\n    border: 1px solid $gray-input-border;\n    border-radius: 5px 5px 0 0;\n  }\n}\n","// LOGO URL\n$logo-url: 'https://res.cloudinary.com/croative/image/upload/v1666945086/benchmark/logo-220x220.png';\n// repeated in constants.js\n\n// FONT SIZES\n$fs-h1: 3.3rem;\n$fs-h2-large: 2.5rem;\n$fs-h2: 1.8rem;\n$fs-h3: 1.4rem;\n$fs-h4: 1.25rem;\n$fs-h5: 1.1rem;\n$fs-sectionTitle: 40px;\n$fs-body: 22px;\n$fs-label: 20px;\n$fs-small: 16px;\n$fs-very-small: 14px;\n\n// Font weights\n$fw-light: 300;\n$fw-normal: 400;\n$fw-medium: 500;\n$fw-semi-bold: 600;\n\n// Font Families\n$ff-primary: 'Barlow', Helvetica, sans-serif;\n$ff-secondary: 'Barlow', Helvetica, sans-serif;\n//$ff-secondary: 'Source Sans Pro', Helvetica, sans-serif;\n\n$max-width: 1420px;\n\n$answer-radio-grid-height: 60px;\n","$red-strongly-disagree-color: #eb5757;\n$orange-disagree-color: #ef8400;\n$orange-somewhat-disagree-color: #efba00;\n$yellow-neutral-color: #ffe921;\n$lime-somewhat-agree-color: #dde041;\n$green-agree-color: #94c556;\n$green-strongly-agree-color: #56c568;\n$gray-answer-circle-color: #686b6f;\n$black-color: #000;\n$gray-color: #aaaaaa;\n$gray-card-background: #f2f2f2;\n$gray-card-border: #bdbdbd;\n$light-gray-input-background: rgba(229, 229, 229, 0.18);\n$gray-input-border: #d9d9d9;\n$light-gray-lines: #cbc8c8;\n$gray-text: #8a8787;\n$orange-button: #f2994a;\n$orange-button-hover: #b06f35;\n$green-icon: #6fcf97;\n$green-bootstrap-success: #198753;\n$test: rgb(150,150,150);\n\n// from Hvar Rentals:\n$dark-blue-color: #154c79;\n$dark-blue-hover-color: #2066a0;\n$light-blue-color: #e4eef7;\n$white-color: #ffffff;\n// $black-color: #000;\n// $gray-color: #aaaaaa;\n$light-gray-color: #eee;\n$red-error-color: #cf062e;\n$test-green-color: #0f7c0b;\n\n$accent_color: orange;\n$bench-logo-anthracite: rgba(56, 57, 55); // #383937 - we use rgba for react-charts\n$bench-logo-anthracite-semi-transparent: rgba(56, 57, 55, 0.6);\n$bench-logo-anthracite-low-transparent: rgba(56, 57, 55, 0.35);\n$bench-logo-blue: rgba(73, 177, 227); // #49B1E3\n$bench-logo-orange: rgba(241, 121, 2); // #F17902\n$bench-logo-orange-semi-transparent: rgba(241, 121, 2, 0.5); // #F17902\n$bench-logo-red: rgba(190, 16, 32); // #BE1020\n$bench-logo-yellow: rgba(254, 213, 0); // #FED500\n$kultivierer-orange: #D27F20;\n$vmi-logo-red: #A6192E;\n\n$EO-Gesamtmodell-red: rgb(255, 0, 0); // #FF0000\n$EO-Gesamtmodell-red-semi-transparent: rgb(255, 0, 0, 0.04); // #FF0000\n$EO-Gesamtmodell-red-active: rgb(255, 0, 0, 0.06); // #FF0000\n$EO-Gesamtmodell-green: rgb(51, 153, 51); // #339933\n$EO-Gesamtmodell-green-semi-transparent: rgb(51, 153, 51, 0.05); // #339933\n$EO-Gesamtmodell-green-active: rgb(51, 153, 51, 0.07); // #339933\n//$EO-Gesamtmodell-gray: rgb(128, 128, 128); // #808080\n//$EO-Gesamtmodell-gray-semi-transparent: rgb(128, 128, 128, 0.9); // #808080\n$EO-Gesamtmodell-black: rgb(0, 0, 0); // #000000\n$EO-Gesamtmodell-black-semi-transparent: rgb(0, 0, 0, 0.04); // #000000\n$EO-Gesamtmodell-black-active: rgb(0, 0, 0, 0.06); // #000000\n\n\n// Note: join two classNames together like this:\n// <div className={styles.container + ' ' + styles.containerActive} />\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftCol": `ChartAndNave_leftCol__MOD6F`,
	"radar": `ChartAndNave_radar__HeUXH`,
	"bar": `ChartAndNave_bar__YYaz7`,
	"noDataTitle": `ChartAndNave_noDataTitle__Ubes2`,
	"rightCol": `ChartAndNave_rightCol__gHem8`,
	"yourResults": `ChartAndNave_yourResults__3RU4c`,
	"linkItem": `ChartAndNave_linkItem__9zf47`,
	"verticalSection": `ChartAndNave_verticalSection__ebymJ`,
	"vLinkItem": `ChartAndNave_vLinkItem__7ZfRO`,
	"moduleTitle": `ChartAndNave_moduleTitle__K2Bl2`,
	"vModuleTitle": `ChartAndNave_vModuleTitle__4+XoL`,
	"selectorSection": `ChartAndNave_selectorSection__REvii`,
	"header": `ChartAndNave_header__gZCuY`,
	"benchScope": `ChartAndNave_benchScope__0GOgE`
};
export default ___CSS_LOADER_EXPORT___;
